import { apCalcABPart1 } from './data-part1';
import { apCalcABPart2 } from './data-part2';
import { apCalcABPart3 } from './data-part3';

export const apCalcABData = [
  ...apCalcABPart1,
  ...apCalcABPart2,
  ...apCalcABPart3,
];
